import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Loader from '../../../../../../../components/sprite/components/loader';
import GmailAddOnSharingDetails from '../../../../gmail-add-on-sharing'
import {
	findLabels,
	getSelectedContactsGroup,
} from '../../../../../../../../actions/contactsGroupItemActions';
import {selectedContacts} from '../../../../../../../../actions/contactActions'
import {contactContent} from '../../../../../../../../actions/contactDetailsActions';
import {showNotesPopup} from '../../../../../../../../actions/popupActions'
import {
	getProfile,
	setActiveLabel,
} from '../../../../../../../../actions/profileActions';
import {getSharingDetailsPopup} from '../../../../../../../../actions/sharingDetailsActions';
import queryString from 'query-string';
import i18n from '../../../../../../../../i18n';
import {I18nextProvider} from 'react-i18next';

const waitTill = () => new Promise((res) => setTimeout(res, 300));


class GmailAddonPopupShareIndividualContact extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {loading: true};
	}

	componentDidMount() {
		this.loadLabels();
	}

	loadLabels = () => {
		this.props.FindLabels(undefined, true);
	};

	commentPopup = async () => {
		let elem;
		let counter = 1;

		while (!elem && counter++ < 70) {
			await waitTill()

			elem = document.querySelectorAll('button.comment-contact-details-button')[0];
			if (elem) {

				elem.click()
				this.props.setNotesValue(true)
			}

		}

	};

	renderPopUp() {
		if (this.props.checkComponentRendering && this.props.checkActiveGmailAddOnLabel !== 'gmail_add_user') {

			let contactId = this.props.location.pathname.split('/');
			let queryParameter = queryString.parse(this.props.location.search);
			if (queryParameter.action === 'addNotes' || queryParameter.action === 'viewNotes') {
				let arrContactId = []
				arrContactId[0] = {id: contactId[3], type: 'contact'}
				this.props.getSharingDetailsPopup([true, 'gmail_contact_details', arrContactId]);
				//this.commentPopup()

				return <GmailAddOnSharingDetails/>;
			} else {
				contactId = contactId[3].split(',');
				let labelId = queryParameter.labelId
				if (labelId) {
					this.props.findLabels.contactsGroups.filter(contactsGroupItem => {

						if (contactsGroupItem.id === labelId) {
							this.props.getSelectedContactsGroup(contactsGroupItem)
						}

						return null;
					})
				}
				if (queryParameter.action === 'view') {
					let arrContactId = []
					arrContactId[0] = {id: contactId[0], type: 'contact'}
					this.props.getSharingDetailsPopup([true, 'gmail_contact_details', arrContactId]);
					this.props.setNotesValue(false)
					this.props.setContactContent('contact-details');
					return <GmailAddOnSharingDetails/>;

				}
				else if (queryParameter.action === 'add') {
					this.props.setActiveLabel('gmail_select_one_label');

					this.props.getSharingDetailsPopup([
						true,
						'gmail_select_one_label',
						[
							{
								id: contactId[0],
								type: 'contact',
							},
						],
						'',
						true,
					])
					return <GmailAddOnSharingDetails/>;
				} else {

					/**
					 * checking if the labels length is greater than 0 then dispatch Select one label popup
					 */

					if (
						this.props.findLabels.contactsGroups.length &&
						!this.props.gmailAddOnContactShare && contactId.length === 1
					) {
						this.props.setActiveLabel('gmail_select_one_label');

						this.props.getSharingDetailsPopup([
							true,
							'gmail_select_one_label',
							[
								{
									id: contactId[0],
									type: 'contact',
								},
							],
							'',
							true,
						]);
					} else if (this.props.findLabels.contactsGroups.length &&
						!this.props.gmailAddOnContactShare && contactId.length > 1) {
						var contactInfo = []
						for (let i = 0; i < contactId.length; i++) {
							var obj = {};
							obj.id = contactId[i];
							obj.type = 'contact';
							obj.shareable = 'true'
							contactInfo.push(obj);
						}
						this.props.setActiveLabel('gmail_select_one_label');

						this.props.getSharingDetailsPopup([
							true,
							'gmail_select_one_label',
							contactInfo
						]);


					}

					/**
					 * If Label doesnt exist
					 */
					else {
						if (this.props.gmailAddOnContactShare) {

							if (
								this.props.findLabels.contactsGroups.length > 0 &&
								this.props.checkActiveGmailAddOnLabel !== 'gmail_add_user' && contactId.length === 1
							) {
								setTimeout(() => {
									this.props.getSharingDetailsPopup([
										true,
										'gmail_add_user',
										contactId[0],
										'',
										'contact',
									]);
								}, 100);
							} else if (this.props.findLabels.contactsGroups.length === 0) {
								this.props.findLabels.systemGroups.filter((systemGroupItem) => {
									if (systemGroupItem.id === '6') {
										this.props.getSelectedContactsGroup(systemGroupItem);
									}
									return null;
								});

								let contactInfo = []
								for (let i = 0; i < contactId.length; i++) {
									let obj = {};
									obj.id = contactId[i];
									obj.type = 'contact';
									obj.shareable = 'true'
									contactInfo.push(obj);
								}
								this.props.setActiveLabel('gmail_add_user');
								this.props.setSelectedContacts(contactInfo);
								this.props.getSharingDetailsPopup([true, 'gmail_add_user', 'first_time']);


							} else if (this.props.findLabels.contactsGroups.length > 0 &&
								this.props.checkActiveGmailAddOnLabel !== 'gmail_add_user' && contactId.length > 1) {


								this.props.getSharingDetailsPopup([
									true,
									'gmail_add_user'])
							}
						}
					}


					return <GmailAddOnSharingDetails/>;
				}
			}
		} else {
			return <GmailAddOnSharingDetails/>;
		}
	}

	render() {
		return (
			<I18nextProvider i18n={i18n}>
				{this.props.findLabels === null ? <Loader/> : this.renderPopUp()}
			</I18nextProvider>
		);
	}
}

const mapStateToProps = (state) => ({
	findLabels: state.contactsGroupItemReducer.findLabels,
	language: state.languageReducer.language,
	checkComponentRendering: state.contactsGroupItemReducer.checkComponentRendering,
	gmailAddOnContactShare: state.contactsGroupItemReducer.gmailAddOnShareContact,
	setGmailAddOnData: state.profileReducer.setGmailAddOnData,
	checkActiveGmailAddOnLabel: state.profileReducer.checkActiveGmailAddOnLabel,
});

const mapDispatchToProps = (dispatch) => ({
	getSharingDetailsPopup: (array) => {
		dispatch(getSharingDetailsPopup(array));
	},
	FindLabels: (pageSize, directLaunch) => {
		dispatch(findLabels(pageSize, directLaunch));
	},
	getSelectedContactsGroup: (object) => {
		dispatch(getSelectedContactsGroup(object));
	},
	getProfile: (boolean) => dispatch(getProfile(boolean)),
	setActiveLabel: (string) => dispatch(setActiveLabel(string)),
	setSelectedContacts: (array) => dispatch(selectedContacts(array)),
	setNotesValue: (boolean) => dispatch(showNotesPopup(boolean)),
	setContactContent: (string) => {
		dispatch(contactContent(string))
	}
});

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(GmailAddonPopupShareIndividualContact)
);
